module.exports = __webpack_public_path__ + "img/io.ioa7c201e.svg";